var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discord_1_",
    "data-name": "discord (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.026,
    height: 14.501,
    viewBox: "0 0 19.026 14.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M16.105,62.074a15.691,15.691,0,0,0-3.873-1.2.059.059,0,0,0-.062.029,10.926,10.926,0,0,0-.482.99,14.483,14.483,0,0,0-4.35,0,10.027,10.027,0,0,0-.49-.99.061.061,0,0,0-.062-.029,15.645,15.645,0,0,0-3.873,1.2.055.055,0,0,0-.025.022A16.057,16.057,0,0,0,.078,72.924a.065.065,0,0,0,.025.045,15.777,15.777,0,0,0,4.751,2.4.062.062,0,0,0,.067-.022,11.277,11.277,0,0,0,.972-1.581.06.06,0,0,0-.033-.084,10.392,10.392,0,0,1-1.484-.707.061.061,0,0,1-.006-.1c.1-.075.2-.153.295-.231a.059.059,0,0,1,.061-.008,11.251,11.251,0,0,0,9.561,0,.059.059,0,0,1,.062.008c.1.079.2.157.3.232a.061.061,0,0,1-.005.1,9.749,9.749,0,0,1-1.485.707.061.061,0,0,0-.032.085,12.667,12.667,0,0,0,.971,1.58.06.06,0,0,0,.067.023,15.724,15.724,0,0,0,4.758-2.4.061.061,0,0,0,.025-.044A15.952,15.952,0,0,0,16.13,62.1.048.048,0,0,0,16.105,62.074ZM6.357,70.763a1.93,1.93,0,0,1,0-3.835,1.93,1.93,0,0,1,0,3.835Zm6.322,0a1.93,1.93,0,0,1,0-3.835,1.93,1.93,0,0,1,0,3.835Z",
    transform: "translate(0.001 -60.871)",
    fill: "#e5bf00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.3b3a2ff5352397bd789dd8b6fa119b7e.svg";
export { ForwardRef as ReactComponent };